import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { ClearPressResponder } from '@react-aria/interactions';
import { useLayoutEffect } from '@react-aria/utils';
import React__default, { useState, useMemo, useContext } from 'react';
import { useIsSSR, FocusScope } from 'react-aria';
import ReactDOM from 'react-dom';
import { useUNSTABLE_PortalContext } from './portal-provider.esm.js';

var OverlayContext = /*#__PURE__*/React__default.createContext(null);

/**
 * A container which renders an overlay such as a popover or modal in a portal,
 * and provides a focus scope for the child elements.
 */
function Overlay(props) {
  var isSSR = useIsSSR();
  var _props$portalContaine = props.portalContainer,
    portalContainer = _props$portalContaine === void 0 ? isSSR ? null : document.body : _props$portalContaine;
  var isExiting = props.isExiting;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    contain = _useState2[0],
    setContain = _useState2[1];
  var contextValue = useMemo(function () {
    return {
      contain: contain,
      setContain: setContain
    };
  }, [contain, setContain]);
  var _useUNSTABLE_PortalCo = useUNSTABLE_PortalContext(),
    getContainer = _useUNSTABLE_PortalCo.getContainer;
  if (!props.portalContainer && getContainer) {
    portalContainer = getContainer();
  }
  if (!portalContainer) {
    return null;
  }
  var contents = props.children;
  if (!props.disableFocusManagement) {
    contents = /*#__PURE__*/React__default.createElement(FocusScope, {
      restoreFocus: true,
      contain: !!contain && !isExiting
    }, contents);
  }
  contents = /*#__PURE__*/React__default.createElement(OverlayContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React__default.createElement(ClearPressResponder, null, contents));
  return /*#__PURE__*/ReactDOM.createPortal(contents, portalContainer);
}

/** @private */
function useOverlayFocusContain() {
  var ctx = useContext(OverlayContext);
  var setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
  useLayoutEffect(function () {
    setContain === null || setContain === void 0 || setContain(true);
  }, [setContain]);
}

export { OverlayContext, Overlay as default, useOverlayFocusContain };
//# sourceMappingURL=overlay.esm.js.map
